import InstitutionsCard from '@/components/Cards/InstitutionsCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import React from 'react'
import style from '../styles/inst_detail.module.scss'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { api } from '@/api'
import { IFetcherListResults } from '@/interfaces/Fetcher'
import Button from '@/components/Button'
import BlockSpinner from '@/components/Spinner/BlockSpinner'

const MoreInstitutions = (): React.ReactElement => {
  return (
    <Section>
      <Title type='h2' theme='h1' className={style.more__title}>
        Еще учреждения
      </Title>

      <FetcherList
        initFilter={{ page_size: 6 }}
        isScrollTop={false}
        isHistoryPush={false}
        api={api.getEducationList}
      >
        {({
          results,
          status,
          showMore,
          isNext
        }: IFetcherListResults<any[]>) => {
          return (
            <>
              <div className={style.more_results}>
                {results.map(el => {
                  return (
                    <InstitutionsCard
                      key={el.id}
                      id={el.id}
                      title={el.name}
                      city={el.property_region_value}
                      site={el.property_link_value}
                      logo={el.preview_picture}
                    />
                  )
                })}
              </div>

              {status === dataStates.loading ? <BlockSpinner /> : null}

              {isNext
                ? (
                  <Button
                    disabled={status === dataStates.loading}
                    onClick={showMore}
                    size='large'
                    wide
                    outline
                    className={style.more__show}
                  >
                    Показать еще
                  </Button>
                  )
                : null}
            </>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default MoreInstitutions
